<template>
  <div class="shopTrain-box">
    <train-list></train-list>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import trainList from '@src/components/trainList'

@Component({
  components: { trainList },
})
export default class Rsxs extends Vue {}
</script>

<style lang="scss" scoped>
.shopTrain-box {
  height: 100%;
  width: 100%;
}
</style>
